import { useState } from "react";
import styled from "styled-components";

import { useDialog } from "~/src/modules/ui-kit";

import List from "./List";
import Finder from "../../../../modules/finder";
import { BIMClass, Parameter, bimClassSearch, parameterSearch } from "../../../../modules/shared-entities";
import Background from "../../components/Background";
import Link from "../../components/Link";
import SearchBait from "../../components/SearchBait";
import Unselect from "../../components/Unselect";
import useSearchKeybind from "../../components/useSearchKeybind";


const StyledInventory = styled.div`
    box-sizing: border-box;
    color: #fff;
    display: flex;
    flex-direction: column;
    gap: 32px;
    padding: 25vh max(64px, 8vw);

    header {
        align-items: baseline;
        display: grid;
        gap: 32px;
        grid-auto-flow: column;
        grid-template-columns: min-content min-content;
        grid-template-rows: min-content min-content;

        .filters {
            display: grid;
            gap: 8px;
            justify-content: start;
        }

        .new {
            flex: none;
            font-family: var(--font-mono);
            font-size: 1.6rem;
            white-space: nowrap;
        }
    }
`;

export default function Inventory() {
    const [parameterID, setParameterID] = useState(undefined);
    const [bimClassID, setBimClassID] = useState(undefined);

    const [Dialog, open, close] = useDialog();

    useSearchKeybind(open);

    function onSelect(name, id, entity) {
        if (name === parameterSearch.name) setParameterID(entity.id);
        if (name === bimClassSearch.name) setBimClassID(entity.id);
        close();
    }

    const query = new URLSearchParams();
    if (bimClassID) query.set("bimClassID", bimClassID);
    if (parameterID) query.set("parameterID", parameterID);

    return (
        <StyledInventory>
            <Background text="revit parameter templates" />
            <header>
                <SearchBait>
                    <input
                        onFocus={ open }
                        placeholder="Search"
                        size="6"
                    />
                    <span>filter templates by Parameter and BIMClass</span>
                    <span>press <i>/</i> or start typing to search</span>
                </SearchBait>
                <Dialog>
                    <Finder
                        modules={ [parameterSearch, bimClassSearch] }
                        onSelect={ onSelect }
                        placeholder="Search"
                    />
                </Dialog>
                <div className="filters">
                    <Parameter
                        distinct
                        id={ parameterID }
                        onClick={ () => setParameterID(undefined) }
                    >
                        <Unselect />
                    </Parameter>
                    <BIMClass
                        distinct
                        id={ bimClassID }
                        onClick={ () => setBimClassID(undefined) }
                    >
                        <Unselect />
                    </BIMClass>
                </div>
                <span className="new">
                    <span>or </span>
                    <Link color="white" to={ `new?${ query.toString() }` }>add new</Link>
                </span>
            </header>
            <List
                bimClassID={ bimClassID }
                parameterID={ parameterID }
            />
        </StyledInventory>
    );
}
